import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  inputvalue: {},
};

const slice = createSlice({
  name: "input",
  initialState,
  reducers: {
    setInput: (state, action) => {
      state.inputvalue = action.payload;
    },
    resetInput: (state, action) => {
      state = initialState;
    },
  },
});

export const { setInput, resetInput } = slice.actions;
export default slice.reducer;
